import {Injectable} from '@angular/core';
import {UserService} from '../api/services/user.service';
import {MapService} from '../api/services/map.service';
import {AccessPermissions, Permission} from './map-user-roles.enum';
import {GraphMap} from '../api/interfaces/graph-node.interface';
import {get, isEmpty} from 'lodash';
import {isInIframe} from '../shared/helpers/maporium.validators';

export const RoleIcons: { [key: string]: string } = {
  VIEWER: 'visibility',
  COMMENTER: 'comment',
  EDITOR: 'edit',
  MANAGER: 'shield'
};

@Injectable({
  providedIn: 'root'
})
export class MapRoleService {


  constructor(private mapService: MapService, private userService: UserService) {
  }

  /** The assistant only exists to change the smap, so viewers and commenters have none. */
  canUseAssistant(map?: GraphMap): boolean {
    const currentMap = map || this.mapService.selectedMap();
    if (!currentMap || isInIframe()) {
      return false;
    }
    return this.hasCurrentUserPermission('edit', currentMap);
  }

  canManage(map?: GraphMap): boolean {
    const currentMap = map || this.mapService.selectedMap();
    if (!currentMap || isInIframe()) {
      return false;
    }
    return this.hasCurrentUserPermission('manage', currentMap);
  }

  hasCurrentUserPermission(permission: Permission, map?: GraphMap): boolean {
    const currentMap = map || this.mapService.selectedMap();
    if (!currentMap || isEmpty(currentMap.userRoles)) {
      return false;
    }
    const user = this.userService.getCurrentUserFromStorage();

    const userRoles = currentMap.userRoles.filter(role => role.user.id === user.id);
    const accessPermissions = AccessPermissions;
    const role = userRoles.find(role => role.user.id === user.id);
    if (role) {
      // @ts-ignore
      return get(accessPermissions, role.role.toLowerCase()).includes(permission);
    } else {
      return false;
    }
  }

  getRoleIcon(role: string): string {
    return RoleIcons[role.toUpperCase()];
  }
}
